/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Copy_ToInputs */

const en_task_catalog_copy_to = /** @type {(inputs: Task_Catalog_Copy_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy to`)
};

const pt_br2_task_catalog_copy_to = /** @type {(inputs: Task_Catalog_Copy_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar para`)
};

/**
* | output |
* | --- |
* | "Copy to" |
*
* @param {Task_Catalog_Copy_ToInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_copy_to = /** @type {((inputs?: Task_Catalog_Copy_ToInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Copy_ToInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_copy_to(inputs)
	return pt_br2_task_catalog_copy_to(inputs)
});